import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRolesEnum } from '@collections/users/enums';
import { QueryRef } from 'apollo-angular';
import { PortalEventsGQL, PortalEventsResponse } from 'app/shared/services/portal-events/graphql/portal-events.gql.service';
import { Observable, skip } from 'rxjs';
import { FieldsOfRelevances } from '@shared/constants/fields-of-relevance';
import { LabelValue } from 'app/shared/constants/labelValue.model';
import { FieldsOfRelevanceEnum } from '@collections/common/enums/fields-of-relevance.enums';
import { SoftDeletePortalEventGQL } from 'app/shared/services/portal-events/graphql/portal-event-delete.gql.service';
import { MetadataService } from 'app/shared/services/meta-data-service/meta-data.service';
import { FooterComponent } from '../../../layout/components/footer/footer.component';
import { CardEditBarComponent } from '../../../shared/components/card-edit-bar/card-edit-bar.component';
import { EventBlockComponent } from '../../../portal-events/views/event-block/event-block.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatDatepickerModule } from '@matheo/datepicker';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatFabButton, MatButton } from '@angular/material/button';
import { CarouselBannerComponent } from '../../../shared/components/carousel-banner/carousel-banner.component';
import { PortalEventsHeaderResponsiveComponent } from './portal-events-headerResponsive/portal-events-headerResponsive.component';
import { PortalEventsHeaderComponent } from './portal-events-header/portal-events-header.component';
import { ToolbarHallsComponent } from '../../../layout/components/toolbar-halls/toolbar-halls.component';
import { RenderIfDirective } from '../../../shared/directives/render-if.directive';
import { OrderType } from '@collections/companies/enums';
import { PagedVirtualScrollerComponent } from 'app/shared/components/paged-virtual-scroller/paged-virtual-scroller.component';
import { UsersService } from 'app/shared/services/users/users.service';
import { BreadcrumbsService, IBreadcrumb } from 'app/shared/services/breadcrumbs/breadcrumbs.service';
@Component({
    selector: 'events-page',
    templateUrl: './portal-events.component.html',
    styleUrls: ['./portal-events.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RenderIfDirective, ToolbarHallsComponent, PortalEventsHeaderComponent, PortalEventsHeaderResponsiveComponent, CarouselBannerComponent, MatFabButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatDatepickerModule, MatSuffix, MatInput, MatSelect, MatOption, MatButton, PagedVirtualScrollerComponent, EventBlockComponent, CardEditBarComponent, FooterComponent]
})
export class PortalEventsComponent implements OnInit {
  breadcrumb: IBreadcrumb[];
  @Input() scaleUpOnRender = true;
  eventsQuery: QueryRef<PortalEventsResponse>;
  skipPortalEvent: string;
  subscription: Observable<any>;
  UserRolesEnum = UserRolesEnum;

  fields: LabelValue<FieldsOfRelevanceEnum>[] = FieldsOfRelevances;
  minDate = new Date(-8640000000000000);

  // [
  //   { id: 0, value: 'all', viewValue: $localize`All fields`, },
  //   { id: 100, value: 'fasteners', viewValue: $localize`Fasteners`, },
  //   { id: 200, value: 'wire', viewValue: $localize`Wire` },
  //   { id: 300, value: 'cables', viewValue: $localize`Cable` },
  //   { id: 400, value: 'ropes', viewValue: $localize`Rope` },
  //   { id: 500, value: 'springs', viewValue: $localize`Spring` },
  //   { id: 600, value: 'tubes', viewValue: $localize`Tube` },
  //   { id: 700, value: 'longProducts', viewValue: $localize`Long products` },
  //   { id: 800, value: 'flatProducts', viewValue: $localize`Flat products` },
  //   { id: 900, value: 'profiles', viewValue: $localize`Profiles` },
  //   { id: 1000, value: 'sheetMetal', viewValue: $localize`Metal sheet` },
  //   { id: 1100, value: 'smallMetalParts', viewValue: $localize`Small metal parts` },
  // ];
  searchForm: UntypedFormGroup;
  isVisible : boolean;

  constructor(
    private portalEventsGQL: PortalEventsGQL,
    private softDeletePortalEventGQL: SoftDeletePortalEventGQL,
    private router: Router,
    private metadataService: MetadataService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private breadcrumbsService: BreadcrumbsService,
    public usersService: UsersService
  ) {
    this.searchForm = this.formBuilder.group({
      searchInput: new UntypedFormControl(),
      fromRangeDate: new UntypedFormControl(),
      toRangeDate: new UntypedFormControl(),
      fieldOfRelevance: new UntypedFormControl(),
    });
  }

  ngOnInit(): void {
    this.breadcrumb = [
      {
        label: $localize`Events`,
        url: "/events"
      }
    ]
    this.breadcrumbsService.store(this.breadcrumb);

    this.metadataService.appendMetadata({
      title: $localize`:events description|titolo della pagina@@EventsTitle:Industry Events and Initiatives`,
      description: $localize`Upcoming events and highlights of the metalworking industry. Find out about conferences, trade shows, webinars, and much more with expometals!`,
      images: ['assets/expometals-social.png'],
      pageType: 'website',
    },
    null,
    'auto');

    this.eventsQuery = this.portalEventsGQL.watch({
      orderType: OrderType.firstin,
      first: 9,
      fromDate: Date.now(),
      skip: 3,
    })

    //this.eventsQuery.valueChanges.pipe(skip(3))
  }

  addPortalEvent(): void {
    this.router.navigate(['../', 'events', 'edit', 'new'], { relativeTo: this.activatedRoute });
  }

  editPortalEvent(event): void {
    this.router.navigate(['../', 'events', 'edit', event._id], { relativeTo: this.activatedRoute });
  }

  softDeletePortalEvent(event): void {
    this.softDeletePortalEventGQL.mutate({
      id: event._id
    })
    .subscribe();
  }

  search(): void {
    this.usersService.checkPermission(() => {
    const fieldOfRelevance = this.searchForm.get('fieldOfRelevance').value;
    const search = this.searchForm.get('searchInput').value

    if (fieldOfRelevance || search){
      this.eventsQuery.refetch({
        orderType: OrderType.firstin,
        fromDate: new Date('01-01-2022'),
        fieldOfRelevance: fieldOfRelevance,
        search: search,
        skip: 0
      });
      this.isVisible = true
    }
  })
  } 

  clear(): void{
    this.eventsQuery.refetch({
      orderType: OrderType.firstin,
      fromDate: Date.now(),
      fieldOfRelevance: null,
      search: null,
      skip: 3
    });
    this.isVisible = false
  }
}
